// src/reducers/pbhorder.reducer.js

import { getRepairsStatusesConstants } from "../constants";

export function statusesRepairs(state = null, action) {
  if (action && action.type) {
    switch (action.type) {
      case getRepairsStatusesConstants.STATUSES_REPAIRS_REQUEST:
        return {};
      case getRepairsStatusesConstants.STATUSES_REPAIRS_SUCCESS:
        return { status: action.orders.status };
      case getRepairsStatusesConstants.STATUSES_REPAIRS_FAILURE:
        return {};

      default:
        return state;
    }
  }
}
